import { useState } from 'react';
import { changePassword } from '../services/authApi';
import { useApi } from './useApi';
import { SessionManager } from '../utils/SessionManager';

interface PasswordData {
  oldPassword: string;
  newPassword: string;
}

/**
 * パスワード変更のためのカスタムフック
 */
export const usePasswordChange = () => {
  const [passwordData, setPasswordData] = useState<PasswordData>({ 
    oldPassword: '', 
    newPassword: '' 
  });
  const [passwordMessage, setPasswordMessage] = useState<string>('');

  // API呼び出しのフックを利用
  const changePasswordApi = useApi(
    async ({ oldPassword, newPassword }: PasswordData) => {
      await changePassword(oldPassword, newPassword);
      return true;
    },
    {
      successMessage: 'パスワードを変更しました',
      onSuccess: () => {
        // 成功時にフォームをリセット
        setPasswordData({ oldPassword: '', newPassword: '' });

        // 管理者リセット後の強制変更フラグをクリア
        SessionManager.setMustChangePassword(false);

        setPasswordMessage('パスワードを変更しました');
        setTimeout(() => {
          setPasswordMessage('');
        }, 3000);
      }
    }
  );

  // フォーム変更ハンドラ
  const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setPasswordData((prev: PasswordData) => ({
      ...prev,
      [name]: value
    }));
  };

  // フォーム送信ハンドラ
  const handlePasswordSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    await changePasswordApi.execute(passwordData);
  };

  return {
    passwordData,
    passwordMessage,
    isChanging: changePasswordApi.loading,
    error: changePasswordApi.error,
    handlePasswordChange,
    handlePasswordSubmit,
  };
}; 
